
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';

export const ADD_RESPONSE_APPLICATIONDATA = '[RESPONSE_APPLICATIONDATA] Add';
export const REMOVE_RESPONSE_APPLICATIONDATA = '[RESPONSE_APPLICATIONDATA] Remove';

// AddPersonalDetails
export class AddApplicationDataResponse implements Action {
    readonly type = ADD_RESPONSE_APPLICATIONDATA;

    constructor(public payload) { }
}
// RemovePersonalDetails
export class RemoveApplicationDataResponse implements Action {
    readonly type = REMOVE_RESPONSE_APPLICATIONDATA;

    constructor(public payload: number) { }
}

export type Actions = AddApplicationDataResponse | RemoveApplicationDataResponse;
